import { Card } from 'callahan-react'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { PageConstants } from '../../constants/page-constants'
import { ADMIN_BASE_URL } from '../../constants/route-constants'

import './admin-panel.css'

class AdminPanel extends Component {
  render() {
    const pageCards = PageConstants.map(page => (
      <Link to={`${ADMIN_BASE_URL}${page.url}`} key={page.title} className="link-card">
        <Card header={page.title} className="card-header">
          <div>
            <span className="card-text">{page.desc}</span>
          </div>
        </Card>
      </Link>
    ))
    return (
      <div className="main-content">
        <h1 className="page-title">Admin Panel</h1>
        <hr />
        <div className="card-container">
          <div className="card-row">{pageCards}</div>
        </div>
      </div>
    )
  }
}

export default AdminPanel



// WEBPACK FOOTER //
// ./src/pages/AdminPanel/AdminPanel.js